window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

    /**
     * Return an object from an array of objects that matches the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    findInstance: function(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    },
  
    /**
     * Remove an object from an array of objects by matching the provided key and value
     *
     * @param {array} array - Array of objects
     * @param {string} key - Key to match the value against
     * @param {string} value - Value to get match of
     */
    removeInstance: function(array, key, value) {
      var i = array.length;
      while(i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }
  
      return array;
    },
  
    /**
     * _.compact from lodash
     * Remove empty/false items from array
     * Source: https://github.com/lodash/lodash/blob/master/compact.js
     *
     * @param {array} array
     */
    compact: function(array) {
      var index = -1;
      var length = array == null ? 0 : array.length;
      var resIndex = 0;
      var result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    /**
     * _.defaultTo from lodash
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
     *
     * @param {*} value - Value to check
     * @param {*} defaultValue - Default value
     * @returns {*} - Returns the resolved value
     */
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
slate.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:section:reorder', this._onReorder.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(container, constructor) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt) {
      var container = $('[data-section-id]', evt.target)[0];
      if (container) {
        this._createInstance(container);
      }
    },
  
    _onSectionUnload: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (!instance) {
        return;
      }
  
      if (typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
  
      this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
    },
  
    _onSelect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onReorder: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onReorder === 'function') {
        instance.onReorder(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor) {
      this.constructors[type] = constructor;
  
      $('[data-section-type=' + type + ']').each(function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this));
    }
  });
  

/*================ Sections ================*/
// =require sections/header.js


/*================ AW Legacy ================*/
/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
    // newImageSrc is the path of the new image in the same size as originalImage is sized.
    // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
    // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
    jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
    jQuery(mainImageDomEl).attr('src', newImageSrc);
  };
  
  jQuery(function($) {
    //reset resizeTimer
    var resizeTimer;
  
    /* Placeholder JS */
    /*==========================*/
    var test = document.createElement('input');
    if (!('placeholder' in test)) {
      $('[placeholder]').each(function(){
        if ($(this).val() === '') {
          var hint = $(this).attr('placeholder');
          $(this).val(hint).addClass('hint');
        }
      });
      $('[placeholder]').focus(function() {
        if ($(this).val() === $(this).attr('placeholder')) {
          $(this).val('').removeClass('hint');
        }
      }).blur(function() {
        if ($(this).val() === '') {
          $(this).val($(this).attr('placeholder')).addClass('hint');
        }
      });
    }
    /* Toggle the filtered-nav on mobile */
    /*==========================*/
  
    $('.mobile-filters-toggle').on('click', function(e) {
      $('.collection__filters-wrapper').show();
    });
  
    $('.mobile-filters-close').on('click', function(e) {
      $('.collection__filters-wrapper').hide();
    });
  
    /* Form validation JS */
    /*==========================*/
  
    $('input.error, textarea.error').focus(function() {
      $(this).removeClass('error');
    });
  
    $('form :submit').click(function() {
      $(this).parents('form').find('input.hint, textarea.hint').each(function() {
        $(this).val('').removeClass('hint');
      });
      return true;
    });
  
    /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
    /*==========================*/
  
    var supportsSVG = function() {
      return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
    }
    if (!supportsSVG()) {
      $('img[src*=".svg"]').remove();
    }
  
    /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
    /*==========================*/
  
    var images = $('.article img').load(function() {
      var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
      var width = $(this).width();
      $(this).attr('src', src).attr('width', width).removeAttr('height');
    });
  
    /* Update main product image when a thumbnail is clicked. */
    /*==========================*/
    $('.product-photo-thumb a').on('click', function(e) {
      e.preventDefault();
      switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
    } );
  
    /* Mobile Search Target Toggler */
    /*==========================*/
    //searchanise fallback if User agent is not a mobile device.
    if (!isMobile()) {
      $('.mobile--search__target').on('click', function() {
        $('#mobile--menu__logo-link').toggle();
        $('#mobile--menu__search').toggle();
      });
    }
  
    /* Menu Switcher */
    /*==========================*/
    $('header').on('click', '.header--menu__item', function() {
      var $menuItem = $(this);
      var isActive = $menuItem.hasClass('active')
  
      if ($menuItem.attr('id') === 'sale') {
        window.location.href = $('#sale--collection').attr('href');
        return;
      }
  
      $headerMenuItems = $('.header--menu__item');
      $headerMenuItems.removeClass('active');
  
      //toggle active class
      if (isActive) {
        $menuItem.removeClass('active');
        $headerMenuItems.show();
      } else {
        $menuItem.addClass('active');
        if (window.matchMedia("(max-width: 1200px)").matches) {
          $headerMenuItems.not('.active').hide();
        }
      }
  
      var menuString = "#menu--" + $(this).attr('id');
      var $menuName = $(menuString);
      if ($menuName.hasClass('menu-open')) {
        $menuName.hide().removeClass('menu-open');
      } else {
        $('.submenu').each(function(idx, el) {
          if (el.classList.contains('menu-open')) {
            $(el).hide();
            $(el).removeClass('menu-open');
          }
        });
        $menuName.show({
          complete: function() {
              $menuName.addClass('menu-open');
              $('#main').on('mouseenter', function() {
                $menuName.hide();
                $menuName.removeClass('menu-open');
                $headerMenuItems.removeClass('active');
                $headerMenuItems.show();
              });
            },
            duration: 0
        });
      }
    });
  
    /* Mobile Header Menu Toggler */
    $('.mobile--menu__target').on('click', function() {
        $('.header--menu__desktop').toggle();
      $('.submenu').hide().removeClass('menu-open');
      $('.header--menu__item').removeClass('active').show();
    });
  
    /* Footer menu toggle */
    $('.link-list > span').on("click", function() {
       $(this).parent().find('.link-list__list').slideToggle();
    });
  
    $('.reviews-container').on('click', function(e) {
      $('html, body').animate({
          scrollTop: $('#shopify-product-reviews').offset().top
      }, 300);
    });
  
    $('.color--item').on('mouseenter', function(e) {
      $('.color-selection').text($(this).attr('title'));
      $(this).one('mouseleave', function() {
        $('.color-selection').text($('#dropdown--color select option:selected').text());
      });
    });
  
    $(window).resize(function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resizeFunction, 100);
    });
  
    resizeFunction();
  
    function resizeFunction() {
      var $columns = $('.submenu--column');
      if (window.matchMedia("(max-width: 1200px)").matches && window.matchMedia("(min-width: 860px)").matches) {
        $columns.removeClass('fourth').addClass('third');
      } else if (window.matchMedia("(max-width: 860px)").matches) {
        $columns.removeClass('fourth third').addClass('half');
      } else {
        $columns.removeClass('third half').addClass('fourth');
        $('.header--menu__desktop, .header--menu__item').show();
      };
  
      if (window.matchMedia("(min-width: 860px)").matches) {
        $('.collection__filters-wrapper').show();
      }
    };
  
    function isMobile() {
      return /iPhone|iPad/i.test(navigator.userAgent) || /Android\s[4-9]/i.test(navigator.userAgent) || /Windows Phone\s[8-9]/i.test(navigator.userAgent)
    }

    $.getJSON( "/cart.json", function(data) {
      var cart_count = data.item_count;
      if (cart_count > 0) {
         $(".text-cart").first().text("Cart " + "(" + cart_count + ")");
      }
   });
    
    
    /*------- SC 2410 ---------*/
    $(".src_sc").click(function () {
      if($('.site-logo').css('display') == 'block')
      {
		$('#dynamic_auto_src_mobile').css( "display", "block" );
        $('.site-logo').css( "display", "none" );
      }
      else{
      	$('#dynamic_auto_src_mobile').css( "display", "none" );
        $('.site-logo').css( "display", "block" );
      }
      //alert('dddd');
    /*if ($(this).hasClass("same-box")) {
      $(".toggle:visible").slideUp();
      $($(this).attr("href")).slideDown();
      return false;
    }
    var myelement = $(this).attr("href");
    $(myelement).slideToggle("fast");
    $(".toggle:visible").not(myelement).slideUp();*/
  });
    /*------- SC 2410 ---------*/
    
    
   
  });
  